const eventObj = {};
const cacheParamsObj = {};

export const resultEmitEvent = (name, cb) => {
  eventObj[name] = cb;
  if (cacheParamsObj[name]) {
    cb(cacheParamsObj[name]);
    cacheParamsObj[name] = null;
  }
};

export const addEmit = (name, e) => {
  if (eventObj[name]) {
    eventObj[name](e);
  } else {
    cacheParamsObj[name] = e;
  }
};
